import {inject, InjectionToken} from '@angular/core';
import {WINDOW} from './window.provider';

export const LOCATION = new InjectionToken<Location>(
  'An abstraction over window.location object',
  { factory: () => inject(WINDOW).location },
);
